"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function AdvSearchButton({ text = "1" }) {
  return (
    <Block className={" adv-search-button-container"} tag={"div"}>
      <Link
        button={true}
        className={"button-3"}
        options={{
          href: "#",
        }}
      >
        {text}
      </Link>
    </Block>
  );
}
